import {
    CoachingRole,
    EventParticipantDetail,
    EventParticipantDto,
} from '../coaching-base/general';

// TODO rename
export function determineNotificationAddress(
    userId: number,
    participants: EventParticipantDto[],
): {
    from: EventParticipantDto;
    to: EventParticipantDto;
} {
    participants = participants || [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const performer =
        participants.find((e) => e.coachingRoleId === CoachingRole.PERFORMER) ||
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({} as EventParticipantDto);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const coach =
        participants.find((e) => e.coachingRoleId === CoachingRole.COACH) ||
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({} as EventParticipantDto);

    // until some other participant role is expected, coach -> performer is the default
    let fromWhich = CoachingRole.COACH;
    let toWhich = CoachingRole.PERFORMER;
    if (userId === performer.id) {
        fromWhich = CoachingRole.PERFORMER;
        toWhich = CoachingRole.COACH;
    }

    const participantForRole = (
        roleId: CoachingRole,
    ): EventParticipantDetail => {
        switch (roleId) {
            case CoachingRole.PERFORMER:
                return performer;
            case CoachingRole.COACH:
                return coach;
            default:
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return { id: userId } as EventParticipantDetail;
        }
    };

    return {
        from: participantForRole(fromWhich),
        to: participantForRole(toWhich),
    };
}
